module.exports = __webpack_public_path__ + "assets/-_6.dac5c49c.svg";